module.exports = "https://referendum2020-campaigns-cdn.fire-emblem-heroes.com/images/303.2629cff1.png";